/*
 * PayPal-Ratenzahlung am Preis (Anpassung dotSHOP, eigene Datei).
 *
 * Laedt das PayPal-JS-SDK mit der Komponente "messages" unter eigenem
 * Namensraum (Shopify laedt fuer die Express-Knoepfe ein zweites SDK mit
 * "buttons"; beide duerfen sich nicht ueberschreiben) und zeichnet den
 * offiziellen Hinweis in jeden [data-ratenzahlung]. Der Text kommt von
 * PayPal und wird nicht veraendert.
 *
 * Produktseite: Betrag = Variantenpreis x Menge, folgt Variante und Menge.
 * Konfigurator: Ratenzahlung.konfigurator(platz, { wert: Euro, dunkel })
 */
(function (global) {
  'use strict';

  var NAMENSRAUM = 'dotshopPaypal';
  var skript = document.querySelector('script[data-ratenzahlung-skript]');
  if (!skript || global.Ratenzahlung) return;

  var sdk = null;
  function ladeSdk() {
    if (sdk) return sdk;
    var p = new URLSearchParams({
      'client-id': skript.getAttribute('data-client-id'),
      components: 'messages',
      currency: 'EUR',
      locale: 'de_DE',
    });
    var haendler = skript.getAttribute('data-merchant-id');
    if (haendler) p.set('merchant-id', haendler);
    sdk = new Promise(function (fertig, fehler) {
      var s = document.createElement('script');
      s.src = 'https://www.paypal.com/sdk/js?' + p.toString();
      s.setAttribute('data-namespace', NAMENSRAUM);
      s.async = true;
      s.onload = function () { fertig(global[NAMENSRAUM]); };
      s.onerror = fehler;
      document.head.appendChild(s);
    });
    return sdk;
  }

  /** Textausrichtung eines Elements in der Schreibweise von PayPal. */
  function ausrichtung(el) {
    var a = getComputedStyle(el).textAlign;
    return /center/.test(a) ? 'center' : /right|end/.test(a) ? 'right' : 'left';
  }

  /** Hinweis fuer el mit Betrag in Euro neu zeichnen. Gleicher Betrag = nichts tun. */
  function zeichne(el, euro) {
    euro = Math.round(euro * 100) / 100;
    if (el._betrag === euro) return;
    el._betrag = euro;
    if (!(euro > 0)) { el.hidden = true; return; }
    ladeSdk().then(function (paypal) {
      if (!paypal || el._betrag !== euro) return;
      el.hidden = false;
      // PayPal zeichnet in einen bereits benutzten Behaelter nicht neu,
      // darum je Betrag ein frisches Element
      var ziel = document.createElement('div');
      el.innerHTML = '';
      el.appendChild(ziel);
      return paypal.Messages({
        amount: euro,
        placement: 'product',
        style: {
          layout: 'text',
          logo: { type: 'inline' },
          text: {
            size: 15,
            color: el._dunkel ? 'white' : 'black',
            align: el._ausrichtung || 'left',
          },
        },
      }).render(ziel);
    }).catch(function () { el.hidden = true; });
  }

  function produkt(el) {
    // Ausrichtung wie der Steuerhinweis unter dem Preis (Shops zentrieren ihn teils per CSS)
    var nachbar = (el.closest('section') || document).querySelector('.product__tax') || el;
    el._ausrichtung = ausrichtung(nachbar);
    el._preis = Number(el.getAttribute('data-betrag')) / 100;
    el._menge = 1;
    var neu = function () { zeichne(el, el._preis * el._menge); };
    neu();
    var bereich = el.closest('section') || document;
    // 'input' fuer das Eintippen, 'change' fuer die Plus-/Minus-Knoepfe
    var mengeNeu = function (ev) {
      if (ev.target && ev.target.name === 'quantity') { el._menge = Math.max(1, Number(ev.target.value) || 1); neu(); }
    };
    bereich.addEventListener('input', mengeNeu);
    bereich.addEventListener('change', mengeNeu);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant;
        if (v) { el._preis = v.price / 100; neu(); }
      });
    } else {
      // Aeltere Dawn-Staende ohne pub/sub: die Variantenauswahl haelt die
      // gewaehlte Variante als currentVariant
      bereich.addEventListener('change', function () {
        setTimeout(function () {
          var auswahl = bereich.querySelector('variant-radios, variant-selects');
          var v = auswahl && auswahl.currentVariant;
          if (v) { el._preis = v.price / 100; neu(); }
        }, 0);
      });
    }
  }

  /**
   * Konfigurator (k5fence-App, auf einer Shopify-Seite eingebettet): Die App
   * stellt einen leeren Platz bereit und meldet den Preis der Konfiguration
   * in Euro; dunkel = heller Text fuer dunklen Grund.
   * Rueckgabe false, wenn kein Betrag gezeichnet werden kann.
   */
  function konfigurator(platz, angaben) {
    if (!platz) return false;
    angaben = angaben || {};
    var el = platz.querySelector('[data-ratenzahlung]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'ratenzahlung ratenzahlung--konfigurator';
      el.setAttribute('data-ratenzahlung', '');
      el.setAttribute('data-ort', 'konfigurator');
      platz.appendChild(el);
    }
    el._ausrichtung = ausrichtung(platz);
    var dunkel = !!angaben.dunkel;
    if (el._dunkel !== dunkel) { el._dunkel = dunkel; el._betrag = null; }
    zeichne(el, Math.max(0, Number(angaben.wert) || 0));
    return true;
  }

  global.Ratenzahlung = { konfigurator: konfigurator };

  function start() {
    document.querySelectorAll('[data-ratenzahlung][data-ort="produkt"]').forEach(produkt);
    // Fuer eingebettete Apps, die vor diesem Skript geladen haben
    document.dispatchEvent(new CustomEvent('ratenzahlung:bereit'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})(typeof window !== 'undefined' ? window : globalThis);
